export default __webpack_public_path__ + "static/media/me-icon.b97728dd.webp";